import { ViewModel } from "../../../Core/CoreTypes";
import { IModel } from "../../../Core/ModelStoring/Model";
import { PathUtils } from "../../../Core/PathUtils/PathUtils";

import {
    ICustomValidationFunctionCallContext,
    ICustomValidationModelAccessor,
} from "./ICustomValidationFunctionCallContext";

export class CustomValidationModelAccessor implements ICustomValidationModelAccessor {
    public readonly form: Omit<ICustomValidationFunctionCallContext, "model" | "requisites">;
    public readonly pathUtils: typeof PathUtils = PathUtils;

    readonly #model: IModel;

    public constructor(callContext: Omit<ICustomValidationFunctionCallContext, "model" | "requisites">, model: IModel) {
        this.form = callContext;
        this.#model = model;
    }

    public getCached(path: string): ViewModel;
    public getCached(path: string, name: "children"): undefined | string[];
    public getCached(path: string, name: "value"): undefined | string;
    public getCached(path: string, name: "touched"): undefined | boolean | string;
    public getCached(path: string, name?: string): undefined | boolean | string | string[] | ViewModel {
        if (name !== "children" && name !== "value" && name !== "touched" && name !== undefined) {
            throw new Error("Only 'children', 'value' and 'touched' allowed as second getCached parameter");
        }
        if (name == undefined) {
            return this.#model.getViewModel(path) ?? {};
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.#model.getViewModelField(path, name);
    }
}
